import {
	RiEyeFill,
	RiFlagFill,
	RiLiveFill,
	RiMicFill,
} from "@remixicon/react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export type ReviewStatus = "mustSee" | "wantToSee" | "sawLive" | "sawStream";

export const STATUS_CONFIG = {
	mustSee: {
		icon: RiFlagFill,
		bg: "bg-radix-violet-9",
		text: "text-radix-violet-1",
		label: "Must See",
	},
	wantToSee: {
		icon: RiEyeFill,
		bg: "bg-radix-plum-9",
		text: "text-radix-plum-1",
		label: "Want to See",
	},
	sawLive: {
		icon: RiMicFill,
		bg: "bg-radix-indigo-9",
		text: "text-radix-indigo-1",
		label: "Saw Live",
	},
	sawStream: {
		icon: RiLiveFill,
		bg: "bg-radix-ruby-9",
		text: "text-radix-ruby-1",
		label: "Saw Stream",
	},
} as const;

interface StatusBadgeProps {
	status: ReviewStatus;
	size?: "xs" | "sm" | "responsive";
	label?: ReactNode;
	compactLabel?: string;
	className?: string;
}

export function StatusBadge({
	status,
	size = "xs",
	label,
	compactLabel,
	className,
}: StatusBadgeProps) {
	const config = STATUS_CONFIG[status];
	const Icon = config.icon;
	const sizeClass =
		size === "responsive"
			? "text-xs sm:text-sm"
			: size === "sm"
				? "text-sm"
				: "text-xs";
	const displayLabel = label ?? config.label;

	return (
		<div
			className={cn(
				"flex items-center gap-1 rounded-lg px-2 py-1",
				config.bg,
				config.text,
				sizeClass,
				className,
			)}
		>
			<Icon className="h-3.5 w-3.5" />
			{compactLabel ? (
				<>
					<span className="hidden sm:inline">{displayLabel}</span>
					<span className="sm:hidden">{compactLabel}</span>
				</>
			) : (
				<span>{displayLabel}</span>
			)}
		</div>
	);
}
